import {
  CreateScheduledEventMetadataInput,
  CreateScheduledEventMetadataMutationVariables,
  DeleteScheduledEventMetadataMutationVariables,
  UpdateScheduledEventMetadataInput,
  UpdateScheduledEventMetadataMutationVariables,
} from '@/API';
import {
  CreateScheduledEventMetadataMutation,
  DeleteScheduledEventMetadataMutation,
  UpdateScheduledEventMetadataMutation,
  createScheduledEventMetadataWithConnection as createScheduledEventMetadataMutation,
  updateScheduledEventMetadataWithConnection as updateScheduledEventMetadataMutation,
  deleteScheduledEventMetadataWithConnection as deleteScheduledEventMetadataMutation,
} from '@/appsync/graphql/scheduledEventMetadata';
import { graphqlQuery } from '@/appsync/service/GraphqlUtils';

export const createScheduledEventMetadata = async (
  scheduledEventMetadata: CreateScheduledEventMetadataInput
): Promise<void> => {
  const variables: CreateScheduledEventMetadataMutationVariables = {
    input: scheduledEventMetadata,
  };

  await graphqlQuery<
    CreateScheduledEventMetadataMutation,
    CreateScheduledEventMetadataMutationVariables
  >(createScheduledEventMetadataMutation, variables);
};

export const updateScheduledEventMetadata = async (
  scheduledEventMetadata: UpdateScheduledEventMetadataInput
): Promise<void> => {
  const variables: UpdateScheduledEventMetadataMutationVariables = {
    input: scheduledEventMetadata,
  };

  await graphqlQuery<
    UpdateScheduledEventMetadataMutation,
    UpdateScheduledEventMetadataMutationVariables
  >(updateScheduledEventMetadataMutation, variables);
};

export const deleteScheduledEventMetadata = async (
  scheduledEventMetadataId: string
): Promise<void> => {
  const variables: DeleteScheduledEventMetadataMutationVariables = {
    input: { id: scheduledEventMetadataId },
  };

  await graphqlQuery<
    DeleteScheduledEventMetadataMutation,
    DeleteScheduledEventMetadataMutationVariables
  >(deleteScheduledEventMetadataMutation, variables);
};
